import { AxiosInstance } from "axios";
import { ResponseDto } from "@common/ict/model/interface/common";

export class ICTServerTimeApi {
  static getServerTime(request: AxiosInstance) {
    return request.get<ResponseDto, ResponseDto>(
      "api/ICTTimeService/GetCurrentTime"
    );
  }
}
